import { useEffect, useRef } from 'react';

interface UseScrollTriggerOptions {
  root?: Element | null;
  rootMargin?: string;
  threshold?: number | number[];
  triggerOnce?: boolean;
  onEnter?: () => void;
}

export const useScrollTrigger = ({
  root = null,
  rootMargin = '0px',
  threshold = 0.2,
  triggerOnce = true,
  onEnter,
}: UseScrollTriggerOptions) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!hasTriggered.current || !triggerOnce) {
            onEnter?.();
            hasTriggered.current = true;
          }
        }
      },
      { root, rootMargin, threshold }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [root, rootMargin, threshold, triggerOnce, onEnter]);

  return ref;
};
